import { create } from 'zustand';

/**
 * Store global para cachear datos de dropdowns
 * Evita llamadas repetidas a endpoints que devuelven datos estáticos o semi-estáticos
 */
export const useDropdownsStore = create((set, get) => ({
  // Estados
  comprobantes: [],
  estadosFactura: [],
  sectores: [],
  
  // Estados de carga
  loadingComprobantes: false,
  loadingEstados: false,
  loadingSectores: false,
  
  // Flags para saber si ya se cargaron
  comprobantesLoaded: false,
  estadosLoaded: false,
  sectoresLoaded: false,
  
  // Parámetros usados para sectores (para invalidar si cambian)
  sectoresParams: { username: null, centroCosto: null },
  
  // Actions
  setComprobantes: (data) => set({ 
    comprobantes: data, 
    comprobantesLoaded: true,
    loadingComprobantes: false 
  }),
  
  setEstadosFactura: (data) => set({ 
    estadosFactura: data, 
    estadosLoaded: true,
    loadingEstados: false 
  }),
  
  setSectores: (data, username, centroCosto) => set({ 
    sectores: data, 
    sectoresLoaded: true,
    loadingSectores: false,
    sectoresParams: { username, centroCosto }
  }),
  
  setLoadingComprobantes: (loading) => set({ loadingComprobantes: loading }),
  setLoadingEstados: (loading) => set({ loadingEstados: loading }),
  setLoadingSectores: (loading) => set({ loadingSectores: loading }),
  
  // Verificar si los sectores necesitan recargarse (por cambio de usuario)
  needsReloadSectores: (username, centroCosto) => {
    const { sectoresParams, sectoresLoaded } = get();
    if (!sectoresLoaded) return true;
    return sectoresParams.username !== username || sectoresParams.centroCosto !== centroCosto;
  },
  
  // Limpiar todo el cache
  clearAll: () => set({
    comprobantes: [],
    estadosFactura: [],
    sectores: [],
    comprobantesLoaded: false,
    estadosLoaded: false,
    sectoresLoaded: false,
    loadingComprobantes: false,
    loadingEstados: false,
    loadingSectores: false,
    sectoresParams: { username: null, centroCosto: null }
  })
}));
